import { lazy } from "react"

export const Abonnements = lazy(() => import("@/views/abonnements/Abonnements"))
export const AbonnementsDataTable = lazy(() => import("components/abonnementsDataTable/AbonnementsDataTable"))